import './PackageMessageRow.scss';

import { Typography } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';

import { useUserContext } from '@/contexts/UserContext';
import { PackageMessage } from '@/model/Logistic/PackageMessage';

interface PackageMessageRowProps {
  message: PackageMessage;
}

const PackageMessageRow = (props: PackageMessageRowProps) => {
  const { message } = props;
  const { userLogged } = useUserContext();
  const displayName = useMemo(() => {
    if (typeof message.origin_user_data === 'number') {
      return message.origin_user_data.toString();
    }

    const firstName = message.origin_user_data?.firstName ?? '';
    const lastName = message.origin_user_data?.lastName ?? '';
    const fullName = `${firstName} ${lastName}`.trim();

    return fullName || message.origin_user_data?.username || 'Usuario';
  }, [message.origin_user_data]);
  const userColor = useMemo(() => {
    const seed = displayName || '';
    let hash = 0;

    for (let i = 0; i < seed.length; i += 1) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;

    return `hsl(${hue}, 60%, 45%)`;
  }, [displayName]);
  const selfMessage = useMemo(
    () =>
      message.origin_user_data == undefined
        ? true
        : typeof message.origin_user_data === 'number'
          ? true
          : userLogged?.username == message.origin_user_data?.username,
    [message.origin_user_data, userLogged?.username],
  );

  return (
    <div className={`PackageMessageRow ${selfMessage ? 'SelfMessage' : ''}`}>
      <div className="PackageMessageRowContent">
        <div className={'PackageMessageRowHeader'}>
          <span className={'PackageMessageRowUser'} style={{ color: userColor }}>
            {displayName}
          </span>
        </div>
        <div className={'PackageMessageRowText'}>{message.text}</div>
      </div>

      <span className={'PackageMessageRowDate'}>
        <Typography.Text type="secondary">{dayjs(message.date).format('L HH:mm')}</Typography.Text>
      </span>
    </div>
  );
};

export default PackageMessageRow;
